"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Print = function Print() {
  return _react["default"].createElement("g", null, _react["default"].createElement("rect", {
    x: "169.501",
    y: "215.771",
    width: "73.026",
    height: "13.696"
  }), _react["default"].createElement("polygon", {
    points: "169.501,202.085 169.49,188.39 279.046,188.37 279.046,202.065 \t"
  }), _react["default"].createElement("rect", {
    x: "169.49",
    y: "160.988",
    width: "109.556",
    height: "13.694"
  }), _react["default"].createElement("rect", {
    x: "169.488",
    y: "133.604",
    width: "36.51",
    height: "13.694"
  }), _react["default"].createElement("rect", {
    x: "169.488",
    y: "133.604",
    width: "36.51",
    height: "13.694"
  }), _react["default"].createElement("rect", {
    x: "169.501",
    y: "215.771",
    width: "73.026",
    height: "13.696"
  }), _react["default"].createElement("polygon", {
    points: "169.49,188.39 169.501,202.085 279.046,202.065 279.046,188.37 \t"
  }), _react["default"].createElement("rect", {
    x: "169.49",
    y: "160.988",
    width: "109.556",
    height: "13.694"
  }), _react["default"].createElement("path", {
    d: "M420.578,252.264h-18.266l-0.005-73.042L301.874,78.81l-141.536,0.014c-25.208,0-45.643,20.431-45.643,45.648 l0.015,127.827H91.887c-25.218,0.025-45.652,20.455-45.652,45.672v54.776c0.02,20.676,13.759,38.098,32.591,43.729 c3.461,21.777,22.279,38.425,45.031,38.425l260.219-0.035c22.359,0,40.924-16.076,44.845-37.295 c21.228-3.924,37.324-22.501,37.313-44.874v-54.786C466.235,272.698,445.775,252.264,420.578,252.264z M160.342,106.212 l146.088-0.014l0.009,68.474h68.474l0.011,77.606l-232.822,0.02l-0.02-127.827C142.082,114.418,150.269,106.212,160.342,106.212z M87.327,325.345c0-10.075,8.174-18.26,18.26-18.26c10.069,0,18.26,8.185,18.26,18.26c0,10.089-8.171,18.255-18.26,18.255 C95.513,343.6,87.327,335.435,87.327,325.345z M384.076,407.479l-260.219,0.04c-6.736,0-12.554-3.693-15.725-9.133l291.661-0.04 C396.622,403.786,390.793,407.479,384.076,407.479z"
  }));
};

Print.displayName = 'Print';
var _default = Print;
exports["default"] = _default;
Print.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Print"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Print.js"] = {
    name: "Print",
    docgenInfo: Print.__docgenInfo,
    path: "src/Print.js"
  };
}